import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import Features from './pages/Features';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';

const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/1crhSUh1mJ5R2c5jLGC8v_yA2eToTXvR6fJ07es3GMzw/viewform';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SurveyRedirect() {
  useEffect(() => { window.location.replace(GOOGLE_FORM_URL); }, []);
  return null;
}

function Layout({ children }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <main style={{ flex: 1 }}>{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/features" element={<Features />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/survey" element={<SurveyRedirect />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
